import { css } from "@emotion/react";

export const link = css`
  white-space: nowrap;
`;

export const fullWidth = css`
  width: 100%;
`;
